import { Text, HStack } from '@genial/components';
import { Spacing } from '@genial/design-tokens';
import { Box } from 'native-base';
import React, { Fragment } from 'react';

export declare namespace FundraisingAnalysisLegendTypes {
  interface PayloadData {
    name: string;
    color: string;
    value: string;
    payload: any;
  }

  interface Props {
    payload?: PayloadData[];
    total: number;
    nameMap: Map<string, string>;
    isMobile?: boolean;
  }
}

export const FundraisingAnalysisLegend: React.FC<FundraisingAnalysisLegendTypes.Props> = ({
  payload,
  nameMap,
  isMobile,
}) => {
  if (!payload || !payload.length) {
    return null;
  }

  const legends = payload.map(({ value, color }) => {
    const name = nameMap.get(value);

    if (!name) {
      return <Fragment key={value.toString()} />;
    }

    return (
      <HStack space={Spacing['stack.quarck']} key={value.toString()}>
        <Box backgroundColor={color} width={Spacing['stack.quarck']} />
        <Text>{name}</Text>
      </HStack>
    );
  });

  return (
    <HStack
      justifyContent={isMobile ? 'end' : 'initial'}
      marginBottom={Spacing['stack.xs']}
      space={Spacing['stack.xxxs']}>
      {legends}
    </HStack>
  );
};
